var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOfParticipants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,13.16A3.74,3.74,0,1,0,8.26,9.43,3.73,3.73,0,0,0,12,13.16ZM10.33,9.43A1.67,1.67,0,1,1,12,11.1,1.67,1.67,0,0,1,10.33,9.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,13.81a6.44,6.44,0,0,0-6.44,6.43v.53H7.62v-.53a4.38,4.38,0,0,1,8.75,0v.53h2.07v-.53A6.44,6.44,0,0,0,12,13.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9,10a3.66,3.66,0,0,1-.05-.57A4.14,4.14,0,0,1,9.39,6.22,3.74,3.74,0,1,0,7.9,10ZM4.06,7A1.67,1.67,0,1,1,5.73,8.64,1.68,1.68,0,0,1,4.06,7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.17,13.13A4.09,4.09,0,0,1,9,12.21a6.41,6.41,0,0,0-3.22-.87A6.35,6.35,0,0,0,2,12.55v3a4.32,4.32,0,0,1,6.46-1.15,6.71,6.71,0,0,1,2.11-.84A5.33,5.33,0,0,0,10.17,13.13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.26,3.23a3.75,3.75,0,0,0-3.66,3,4.12,4.12,0,0,1,1.55,3.21,3.66,3.66,0,0,1,0,.57,3.67,3.67,0,0,0,2.16.7,3.74,3.74,0,1,0,0-7.47Zm0,5.41A1.68,1.68,0,1,1,19.93,7,1.67,1.67,0,0,1,18.26,8.64Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22,12.55a6.37,6.37,0,0,0-6.95-.34,4.13,4.13,0,0,1-1.23.92c-.14.13-.27.28-.4.42a6.86,6.86,0,0,1,2.12.84A4.32,4.32,0,0,1,22,15.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOfParticipants);
export default __webpack_public_path__ + "static/media/no-of-participants.37e14316328fc5c8b2a7c6439fb87172.svg";
export { ForwardRef as ReactComponent };